import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Snackbar from '@mui/material/Snackbar'

import { useAlerts } from '../hooks/useAlerts'

export const Alerts = () => {
  const { alert, clear: onClose } = useAlerts()
  const { severity, title, message, messageDetail, duration } = alert

  if (severity === 'none') {
    return <></>
  }

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      autoHideDuration={duration}
      onClose={onClose}
      open
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{ width: '100%' }}
        onClick={onClose}
      >
        {title && <AlertTitle>{title}</AlertTitle>}

        {messageDetail ? (
          <Box sx={{ pt: 1, pb: 1 }}>
            <div>{message}</div>
            <em>{messageDetail}</em>
          </Box>
        ) : (
          <div>{message}</div>
        )}
      </Alert>
    </Snackbar>
  )
}
